import { render } from "./MiniStatisticsCard.vue?vue&type=template&id=521f239e"
import script from "./MiniStatisticsCard.vue?vue&type=script&lang=js"
export * from "./MiniStatisticsCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ibrahimisa/Documents/Work/HibSoft/Projects/Frontier-Systems/Projects/geep-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__